omadapp.controllers.end_gameController = function($page) {
	var t = this
	var $ = jQuery
    var app = omadapp.App
    var quiz = app.config.quizz
    var $js_title = $page.find(".js_title")
    var $js_feedback_text = $page.find(".js_feedback_text")
    var $js_feedback = $page.find(".js_feedback")

    var resizeDone = false
    var $js_share

	t.onPreCurrent = onPreCurrent
	t.onCurrent = onCurrent
	t.preparePage = preparePage



	function preparePage (scores) {
		trace ("end_game::preparePage")
		trace (scores)
    	$js_title.text(quiz.title)

    	var score = getScore(scores)
    	trace (score)
    	manageScore(score)
    	manageFeedback(score)
		
	}

	function getScore (scores) {
		var score = 0;
		for (var n in scores) {
			score+=scores[n]
		}
		return score
	}

	function manageScore(score) {
		if (quiz.track_score!="1"&&quiz.track_score!="true") {
			$page.find(".js_score").addClass("hidden")
		} else {
			$page.find(".js_score").removeClass("hidden")
			$page.find(".js_score_points .js_counter").text(score)
		}
	}
	function manageFeedback(score) {
		if (!quiz.feedback) {
			$js_feedback_text.addClass("hidden")
			return;
		}

		var arr = []
		for (var n in quiz.feedback) {
			var itm = quiz.feedback[n]
			if (itm.max_score==null) {
				itm.noScore = true
				itm.max_score=0
			} else {
				itm.max_score = Number(itm.max_score)
			}
			arr.push(itm)
		}
		arr.sort((a, b) => a.max_score - b.max_score);
		var selectedFeedback 
		for (var i = 0; i < arr.length; i++) {
			trace (score+"  "+arr[i].max_score)
			if (score<=arr[i].max_score&&!arr[i].noScore) {
				selectedFeedback = arr[i]
				break
			}
		}
		if (!selectedFeedback) {
			for (var i = 0; i < arr.length; i++) {
				if (arr[i].noScore) {
					selectedFeedback = arr[i]
					break
				}
			}
		}
		if (!selectedFeedback) {
			$js_feedback_text.addClass("hidden")
		} else {
			$js_feedback_text.html(selectedFeedback.text)
			$js_feedback_text.removeClass("ok ko neutral hidden")
			$js_feedback.removeClass("ok ko neutral hidden")
			$js_feedback_text.addClass(selectedFeedback.correction)
			$js_feedback.addClass(selectedFeedback.correction)
		}
	}


	function onPreCurrent() {

	}
	function onCurrent() {
		if (!resizeDone) {
			$js_share = $page.find(".js_share>span")
			resizeDone = true
			$(window).resize(function(e) {
				checkWindowWidth()
			})
		}
		checkWindowWidth()
	}
	function checkWindowWidth() {

		if (window.innerWidth>992) {
			$page.find(".js_wrapper").append($js_share)
		} else {
			$page.find(".js_share").append($js_share)
		}
	}
}